<template>
	<div>
		<el-card class="box-card" :label="title" shadow="hover" v-for="(item, index) in pageset" :key="index">
			<div slot="header" class="clearfix">
				<span>包裹信息</span>
			</div>
			<div v-for="(i, idx) in item.setlist" style="margin-top:-30px">
				<div v-if="i.controltype == 'table'">
					<tableui
						ref="cargo"
						editcell="1"
						:tableData="i.cargolist"
						:columns="columns"
						@gridhandle="val => gridhandle(val, i, idx)"
						@autoaddrow="val => gridhandle(val, i, idx)"
						:gridheight="gridheight"
						emptytext="请添加商品"
					></tableui>
					<!-- <el-row v-if="isselcargo">
						<el-col :span="10" style="color:transparent">1</el-col>
						<el-col :span="10">
							 <el-button size="medium" type="primary" round @click="selectcargolist"><i class="el-icon-circle-plus"></i> 从商品库中添加</el-button>
						</el-col>
					</el-row> -->
				</div>
			</div>
		</el-card>
		<!-- <selectcargo ref="selectcargo" @addcargorow="addcargorow" @closecargo="closecargo"></selectcargo> -->
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
import selectcargo from '@/components/baseinfo/selectcargo.vue';
//import cargolist from '@/pages/baseinfo/cargolist';
export default {
	components: {
		tableui,
		selectcargo
		//cargolist
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		l_mode: {
			type: String,
			default: ''
		},
		gridheight: {
			type: String,
			default: '100px'
		},
		isselcargo:{
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			//packageindex: 0,
			//orderempty:[{ index: 1,p_pkval:'',cargolist:[],baginfo:{packageweight:1,}}],
			orderinfo: {},
			pageset: [],
			setlist: [],
			columns: [],
			cargorow: {},
			gridrowindex: 0,
			handle: {
				field: '',
				title: '操作',
				type: 'template',
				template: [
					{ type: 'link', title: '添加', icon: '', handletype: 'success', event: 'addrow' },
					{ type: 'link', title: '删除', icon: '', handletype: 'danger', event: 'delrow' }
				],
				width: 120,
				sortable: false,
				evttype: 'click',
				colshow: '1',
				event: ''
			},
			iscopy:0,
			cargoparam:{},
			cargolist:[],
			gridcolindex: -1,
		};
	},
	mounted() {},
	methods: {
		init(param) {
			//debugger
			var that = this;
			if (param.syscol != undefined) {
				this.syscol = param.syscol;
			}
			if (param.iscopy != undefined) this.iscopy = param.iscopy;
			if (param.orderinfo != undefined) this.orderinfo = param.orderinfo;
			this.setlist = [];
			this.getcargosetlist();
		},
		//包裹列表的信息
		getcargosetlist() {
			//debugger
			var that = this;
			//debugger
			this.$apipost.get.GetPagecolSet({ syscol: this.syscol, l_mode: '包裹信息列表-进口' }).then(res => {
				if (res.length > 0) {
					that.setlist.splice(0, 0, res[0]);
					that.columns = JSON.parse(JSON.stringify(res[0].table));
					that.handle.index = that.columns.length + 1;
					that.columns.push(that.handle);
					that.setcargocol(res[0].table);
					//debugger
					that.setpagelayout();
				}
			});
		},
		//生成默认行
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargorow = JSON.parse(cargo)[0];
			
			
		},
		//设置页面数据
		setpagelayout() {
			
			var that = this;
			this.pageset = [];
			this.pageset.push({ setlist: JSON.parse(JSON.stringify(this.setlist)) });
			if (this.orderinfo.list==undefined) {
				this.pageset.forEach(e => {
					e.setlist.forEach(s => {
						if (s.controltype == 'table') {
							
							s.cargolist = [];
							if(!this.isselcargo)
								s.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
						}
					});
				});
			}else{
				var index=0;
				//包裹列表
				this.orderinfo.list.forEach(e=>{
					if(index>0)
						that.pageset.push({ setlist: JSON.parse(JSON.stringify(that.setlist)) });
					that.pageset[index].setlist.forEach(s => {
						if (s.controltype == 'table') {
							s.table.forEach(t=>{
								if(t.type=='picker')
								{
									e.cargolist.forEach(cc=>{
										if(cc[t.field]!=undefined){
											cc[t.field]=that.gettreenode(cc[t.field],t.source);
										}
									});
									return false;
								}
							});
							debugger
							s.cargolist = e.cargolist;
							if(s.cargolist.length==0)
							{
								if(!that.isselcargo)
									s.cargolist.push(JSON.parse(JSON.stringify(that.cargorow)));
							}
						}
					});
					index++;
				});
			}
		},
		gettreenode(value,source){
			var treelist=[];
			var nodelist1=[];
			var nodelist2=[];
			if(source.length>0){
				var list=JSON.parse(JSON.stringify(source));
				for(var i=0;i<list.length;i++){
					if(list[i].label==value){
					{
						treelist.push(list[i].label);
						break;
					}
					}else{
						if(list[i].children!=undefined){
							nodelist1.push(list[i].label);
							for(var s=0;s<list[i].children.length;s++){
								if(list[i].children[s].label==value)
								{
									treelist.push(list[i].children[s].label);
									break;
								}
								else
								{
									if(list[i].children[s].children!=undefined){
										nodelist2.push(list[i].children[s].label);
										for(var ss=0;ss<list[i].children[s].children.length;ss++){
											if(list[i].children[s].children[ss].label==value)
											{
												treelist.push(list[i].children[s].children[ss].label);
												break;
											}	
										}
									}
									if(treelist.length>0)
										break;
								}
							}
						}
						if(treelist.length>0)
							break;
					}
				}
			}
			if(treelist.length==0)
				treelist='';
			else{
				var list=JSON.parse(JSON.stringify(treelist));
				if(nodelist1.length>0)
				{
					treelist=nodelist1;
					if(nodelist2.length>0){
						treelist.push(nodelist2[0]);
						treelist.push(list[0])
					}
					else
						treelist.push(list[0])
				}
				else
					treelist=list;
			}
			return treelist;
		},
		//获取商品勾选行
		GetCargo(e,i) {
			//获取商品信息
			var that = this;
			var rowindex = e.index;
			var colindex = e.colindex;
			this.gridrowindex = rowindex;
			this.gridcolindex = colindex;
			var search = new Object();
			var field = e.field;
			search[field] = i.cargolist[rowindex][field];
			if(search[field]==''||search[field]==undefined){
				return false;
			}
			var paraminfo = {
				search: JSON.stringify(search),
				pageindex: 0,
				pagesize: 200,
				sort: '',
				tab: 'tab1',
				l_mode: '商品库管理',
				showcol: '',
				userid: localStorage.getItem('userid')
			};
			debugger
			// console.log('商品',escape(JSON.stringify(paraminfo)));
			// return false;
			this.$tool.loading('正在获取商品', this.divclass);
			this.$apipost.get.GetBaseCargoList({ paraminfo: paraminfo }).then(res => {
				this.$tool.loadingclose();
				//console.log('商品信息',res,);
				if (res.count>0)
					that.addcargorow(res.data,i);
			});
		},
		//列表操作列
		gridhandle(e, i, index) {
			var that = this;
			if (e.event == 'addrow') {
				if(this.isselcargo)
					i.cargolist.splice(e.index + 1, 0, JSON.parse(JSON.stringify(this.cargorow)));
				else
					i.cargolist.push(JSON.parse(JSON.stringify(this.cargorow)));
				
			}
			if (e.event == 'delrow') {
				this.deleteRow(e, i, index);
			}
			if (e.event == 'getcargo') {
				this.GetCargo(e,i); //获取商品基本信息
			}
		},
		//删除行
		deleteRow(e, i, index) {
			i.cargolist.splice(e.index, 1);
			if (i.cargolist.length < 1) {
				i.cargolist.push(JSON.parse(JSON.stringify(this.cargorow)));
			}
		},
		selectcargolist(){
			//
			this.$refs.selectcargo.init({searchparam:'1'});
		},
		addcargorow(rows,i, isclose) {
			var isset=false;
			if (isclose == undefined) isclose = false;
			var that = this;
			var rowindex = this.gridrowindex;
			if(i!=undefined){
				//判断新添加的商品是否已存在在已添加列表中，有则累加数量，没有则新增行
				i.cargolist.forEach(e => {
					var index = 0;
					rows.forEach(r => {
						if (r.id == e.id && e.id != '') {
							e.num = parseInt(e.num) + 1;
							//移除此行
							rows.splice(index, 1);
						}
						index++;
					});
				});
				rows.forEach(e => {
					if (rowindex > that.gridrowindex) i.cargolist.splice(rowindex, 0, JSON.parse(JSON.stringify(this.cargorow)));
					for (var key in i.cargolist[rowindex]) {
						for (var cargokey in e) {
							if (cargokey == key) {
								i.cargolist[rowindex][key] = e[key];
								break;
							}
						}
						if (key == 'num'&&(i.cargolist[rowindex][key]==''||i.cargolist[rowindex][key]=='0')) i.cargolist[rowindex][key] = '1';
					}
					rowindex++;
				});
			}
			else{
				that.pageset.forEach(p=>{
					p.setlist.forEach(s=>{
						if(s.controltype=='table')
						{
							s.cargolist.forEach(e => {
								var index = 0;
								rows.forEach(r => {
									if (r.id == e.id && e.id != '') {
										e.num = parseInt(e.num) + 1;
										//移除此行
										rows.splice(index, 1);
									}
									index++;
								});
							});
							rows.forEach(e => {
								if (rowindex > that.gridrowindex) s.cargolist.splice(rowindex, 0, JSON.parse(JSON.stringify(that.cargorow)));
								for (var key in s.cargolist[rowindex]) {
									for (var cargokey in e) {
										if (cargokey == key) {
											s.cargolist[rowindex][key] = e[key];
											break;
										}
									}
									if (key == 'num'&&(s.cargolist[rowindex][key]==''||i.cargolist[rowindex][key]=='0')) s.cargolist[rowindex][key] = '1';
								}
								rowindex++;
							});
							isset=true;
							return false;
						}
					});
					if(isset)
						return false;
				});
			}
			if (isclose) this.closecargo();
			else {
				if (rows.length > 0) {
					this.$refs.cargo[0].setfoucsbyindex(this.gridrowindex, undefined, 'num');
				}
			}
			this.$emit('addedcallback', {
				gridrowindex:this.gridrowindex
			});
		},
		//关闭选择商品
		closecargo() {
			var that=this;
			var isset=false;
			that.pageset.forEach(p=>{
				p.setlist.forEach(s=>{
					if(s.controltype=='table')
					{
						if (s.cargolist[that.gridrowindex].id != undefined) this.$refs.cargo[0].setfoucsbyindex(that.gridrowindex, undefined, 'num');
						isset=true;
						return false;
					}
				});
				if(isset)
					return false;
			});
		},
		surecargo(){
			this.closecargo();
		}
	}
};
</script>

<style></style>
